import { notification } from "antd";

type NotificationType = "success" | "info" | "warning" | "error";

export const openNotificationWithIcon = (
  message: string = "Notification Title",
  description: string = "",
  type: NotificationType = "success",
  key?: "default_key",
  placement?: "topRight",
) => {
  notification[type]({
    message,
    description,
    duration: 10,
    placement,
    maxCount: 2,
    key,
  });
};
